
const collectionPageSchema = ({
  url,
  title,
  description,
  image,
  items = [],
}) => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "@id": `${url}#webpage`,
  url,
  name: title,
  description,
  isPartOf: {
    "@id": "https://irisimpulse.com/#website",
  },
  about: {
    "@id": "https://irisimpulse.com/#organization",
  },
  ...(image && {
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: image,
    },
  }),
  mainEntity: {
    "@type": "ItemList",
    itemListOrder: "https://schema.org/ItemListUnordered",
    numberOfItems: items.length,
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      url: item.url,
    })),
  },
  inLanguage: "en",
});
export default collectionPageSchema;